module.exports = "/_next/static/images/buyers_2-1fd311daa312f6521e5b66885db04ff1.png";